import '../styles/purple-btn.css'

export default function PurpleBtn({width='129',text=''}) {
  return (
    <button style={{width:`${width}px`}} className='purple-btn'>
        {text}
    </button>
  )
}
